import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";

import List from "@mui/material/List";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import {
  Home as HomeIcon,
  Help as HelpIcon,
  ExpandLess,
  ExpandMore,
  VpnKey,
} from "@mui/icons-material";

export const DrawerContent = ({ onClick, items = [], onOpenModal }) => {
  const [openMenus, setOpenMenus] = useState({});

  const handleToggle = (menuName) => {
    setOpenMenus((prev) => ({ ...prev, [menuName]: !prev[menuName] }));
  };

  const handleItemClick = (item) => {
    if (item.action === "openModal") {
      onOpenModal();
    } else if (item.action) {
      item.action();
    }
    onClick();
  };

  return (
    <Box onClick={onClick} className="drawer-content">
      <List>
        {items?.map((item) => (
          <div key={item.name}>
            <ListItemButton
              component={item.external ? "a" : RouterLink}
              to={!item.external ? item.link : undefined}
              href={item.external ? item.link : undefined}
              target={item.external ? "_blank" : undefined}
              rel={item.external ? "noopener noreferrer" : undefined}
              onClick={
                item.action && item.action !== "openModal"
                  ? () => handleItemClick(item)
                  : item.dropdown
                    ? (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleToggle(item.name);
                      }
                    : item.action === "openModal"
                      ? () => handleItemClick(item)
                      : undefined
              }
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.name} />
              {item.dropdown && (
                <IconButton edge="end" size="small">
                  {openMenus[item.name] ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
              )}
            </ListItemButton>
            {item.dropdown && (
              <Collapse in={openMenus[item.name]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {item.dropdown.map((subItem) => (
                    <ListItemButton
                      key={subItem.name}
                      component={subItem.external ? "a" : RouterLink}
                      to={!subItem.external ? subItem.link : undefined}
                      href={subItem.external ? subItem.link : undefined}
                      target={subItem.external ? "_blank" : undefined}
                      rel={subItem.external ? "noopener noreferrer" : undefined}
                      className="drawer-subitem"
                    >
                      <ListItemIcon>
                        <HelpIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary={subItem.name} />
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            )}
          </div>
        ))}
      </List>
    </Box>
  );
};

export const menuItems = [
  {
    name: "Home",
    icon: <HomeIcon />,
    link: "/",
  },
  {
    name: "List of Awards",
    icon: <HelpIcon />,
    link: "/awards-page",
    // external: true,
    // link: "https://sas2.nlsf.ca/ScholarshipBook.aspx",
  },
  {
    name: "FAQs",
    icon: <HelpIcon />,
    external: true,
    link: "https://www.nlsf.ca/scholarships-bursaries/faq/",
  },
  {
    name: "Additional Awards",
    icon: <HelpIcon />,
    external: true,
    link: "/awards-page",
  },
  {
    name: "Download Award Book PDF",
    icon: <VpnKey />,
    action: "openModal",
  },
];
